"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionMode = void 0;
var InteractionMode;
(function (InteractionMode) {
    InteractionMode["DoubleClickItemToExpand"] = "double-click-item-to-expand";
    InteractionMode["ClickItemToExpand"] = "click-item-to-expand";
    InteractionMode["ClickArrowToExpand"] = "click-arrow-to-expand";
})(InteractionMode = exports.InteractionMode || (exports.InteractionMode = {}));
